import React, { useState } from "react";
import { Button, Input } from "reactstrap";
import * as XLSX from "xlsx";

const ExcelPurchaseImport = ({ setInvoiceSheet }) => {
  const [fileName, setFileName] = useState("");

  // 1. Download sample template with exact headers and an example row
  const downloadSampleTemplate = () => {
    const templateData = [
      {
        item: "Cycle zabarsasth quality sortex cleaned Toor dal 30 kg bopp bag",
        quantity: 30,
        unitPrice: "91",
        tax: "none",
        mrp: "91",
        hsn: "07139090",
        batch: "TOORDAL",
        productId: "SKU00091",
        stockQty: 30,
        expiry: "2025-08-30",
        minStockLevel: "15 KG",
        maxStockLevel: "40 KG",  
        unit: "Kg",
        category: "Grocery"
      }
    ];
    
    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "PurchaseItems");
    XLSX.writeFile(wb, "Purchase_Template_Format.xlsx");
  };

  // 2. Upload and map excel rows directly to your precise schema structure
  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFileName(file.name);
    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const bstr = evt.target.result;
        const workbook = XLSX.read(bstr, { type: "binary" });
        
        const wsname = workbook.SheetNames[0];
        const ws = workbook.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, { defval: "" });
        if (data.length === 0) {
          alert("The uploaded Excel file is empty.");
          return;
        }

        // Map every row precisely to your specified fields
        const formattedItems = data.map((row) => ({
          item: String(row["item"] || "").trim(),
          quantity: Number(row["quantity"] || 1),
          unitPrice: String(row["unitPrice"] || "0.00"),
          tax: String(row["tax"] || "none"),
          mrp: String(row["mrp"] || "0.00"),
          hsn: String(row["hsn"] || ""),
          batch: String(row["batch"] || ""),
          productId: row["productId"] ? String(row["productId"]) : null,
          stockQty: row["stockQty"] !== "" ? Number(row["stockQty"]) : null,
          expiry: String(row["expiry"] || ""),
          minStockLevel: String(row["minStockLevel"] || ""),
          maxStockLevel: String(row["maxStockLevel"] || ""),
       
          unit: String(row["unit"] || "PC"),
          category: String(row["category"] || "")
        })).filter(item => item.item !== "");

        setInvoiceSheet(formattedItems);
        alert(`Successfully imported ${formattedItems.length} items into the invoice form!`);
      } catch (error) {
        console.error("Excel Parsing Error:", error);
        alert("Failed to parse the Excel file. Please ensure it uses the downloaded template format.");
      }
    };

    reader.readAsBinaryString(file);
  };

  return (
    <div className="p-4 border rounded bg-light mb-4 shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="font-weight-bold m-0">Bulk Excel Import & Template</h5>
        <Button color="primary" size="sm" onClick={downloadSampleTemplate}>
          📥 Download Excel Template Format
        </Button>
      </div>

      <div className="row g-3 align-items-center">
        <div className="col-md-8">
          <Input 
            type="file" 
            accept=".xlsx, .xls, .csv" 
            onChange={handleExcelUpload} 
          />
          {fileName && <small className="text-muted d-block mt-1">Loaded File: {fileName}</small>}
        </div>
        <div className="col-md-4">
          <small className="text-muted d-block">
            Upload your filled spreadsheet here to instantly populate the UI rows with all parameters.
          </small>
        </div>
      </div>
    </div>
  );
};

export default ExcelPurchaseImport;